import type { TabKeys, TabParamKeys } from "@/constants/TabKeys";

import { useSearchParams } from "react-router";

export const useIsTabActive = ({
  tabKey,
  tabValue,
  isDefaultTab,
}: {
  tabKey: TabParamKeys;
  tabValue: TabKeys;
  isDefaultTab: boolean;
}) => {
  const [searchParams] = useSearchParams();
  const currentTabValue = searchParams.get(tabKey);

  return tabValue === currentTabValue || (isDefaultTab && !currentTabValue);
};
